import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=bd7c1ee0&scoped=true&"
import script from "./S3Image.vue?vue&type=script&lang=js&"
export * from "./S3Image.vue?vue&type=script&lang=js&"
import style0 from "./S3Image.vue?vue&type=style&index=0&id=bd7c1ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c1ee0",
  null
  
)

component.options.__file = "S3Image.vue"
export default component.exports